<template>
  <div class="container">
    <h2><strong>Contract of Income Sharing Agreement with Upskill</strong></h2>
    <p>&nbsp;</p>
    <p>
      <span style="font-weight: 400;"
        >This agreement shall commence upon Application to the Course and
        will continue to be effective henceforth. This agreement is entered into
        by and between Upskill and </span
      ><span style="font-weight: 400;"> And the Applicant</span
      ><span style="font-weight: 400;"
        > hereinafter referred to as Candidate.</span
      >
    </p>
    <p>&nbsp;</p>
    <p><strong>Privacy and Data</strong></p>
    <p>
      <span style="font-weight: 400;"
        >By sharing resume and data with Upskill, the Candidate is allowing
        Intelligent Machines to have access to the resume and data as well.</span
      >
    </p>
    <p>&nbsp;</p>
    <p><strong>Terms of Participation</strong></p>
    <ol>
      <li style="font-weight: 400;">
        <span style="font-weight: 400;"
          >The Candidate will participate in the beginner to job ready with Machine Learning and Artificial Intelligence course hosted by Upskill.
</span
        >
      </li>
      <li style="font-weight: 400;">
        <span style="font-weight: 400;"
          >Upon the completion of the Machine Learning course, the Candidate will participate in a recruitment process designed by Intelligent Machines upon successful completion of the Machine Learning course and passing of the assessment, the Candidate will be forwarded to a round of interviews with Intelligent Machines.
</span
        >
      </li>
      <li style="font-weight: 400;">
        <span style="font-weight: 400;"
          >Upon successful completion of the Machine Learning course and passing of the assessment, the Candidate will be forwarded to an interview with Intelligent Machines.
</span
        >
      </li>
      <li style="font-weight: 400;">
        <span style="font-weight: 400;"
          >Completion of the Machine Learning course and passing of the assessment does not guarantee a job offer for the Candidate.
</span
        >
      </li>

      <li style="font-weight: 400;">
        <span style="font-weight: 400;"
          >In case a Candidate is recruited by Intelligent Machines, he/she will be required to pay Upskill a total of BDT 50,000 in 5 equal installments (Tk. 10,000/monthly) after being confirmed as a full-time employee as part of the Income Sharing Agreement between the Candidate and Upskill.
</span
        >
      </li>
      <li style="font-weight: 400;">
        <span style="font-weight: 400;"
          >If the Candidate is selected, then he/she will be required to deposit Tk. 3,000, which will be refunded once the program is completed. This is to ensure that the Candidate does not drop out in the middle of the course.
&nbsp;</span
        >
      </li>
      <li style="font-weight: 400;">
        <span style="font-weight: 400;"
          >Under no circumstance, is the applicant allowed to share solutions to the problems/projects done in this course. Violation of this will result in disqualification and legal action against the applicant. Please remember that the tech community is close knit and violations will be easily detected.
&nbsp;</span
        >
      </li>
    </ol>
    <p>&nbsp;</p>
    <p><strong>Confidentiality</strong></p>
    <p>
      <span style="font-weight: 400;"
        >The Candidate cannot share the contents of the workshop or solutions to
        the assessment with any third party, including the assessment materials,
        questions or answers. </span
      ><strong
        >Violation of the confidentiality clause will result in termination of
        certification and/or employment if the Candidate gets
        placed.&nbsp;</strong
      >
    </p>
    <p>&nbsp;</p>
    <p>
      <span style="font-weight: 400;"
        >By signing this agreement, the Candidate accepts the Confidentiality
        Clause including the following:</span
      >
    </p>
    <ol>
      <li style="font-weight: 400;">
        <span style="font-weight: 400;"
          >To keep all information gained during and within the Upskill Machine Learning Course and the Intelligent Machines Assessments confidential.
</span
        >
      </li>
      <li style="font-weight: 400;">
        <span style="font-weight: 400;"
          >To use any content shared with him/her by Upskill and Intelligent Machines only in accordance with applicable privacy and data protection laws.
</span
        >
      </li>
      <li style="font-weight: 400;">
        <span style="font-weight: 400;"
          >To not disclose the names or identities or share the profile of any other Candidate partaking the Machine Learning course outside of the course or parties involved.
</span
        >
      </li>
      <li style="font-weight: 400;">
        <span style="font-weight: 400;"
          >To take appropriate physical, technical and administrative measures to protect content he/she obtains through participation in the Upskill Machine Learning Course and use of the Intelligent Machines Assessments from loss, misuse, unauthorized access, disclosure, alteration or destruction.
</span
        >
      </li>
    </ol>
    <p>&nbsp;</p>
    <p><strong>Upskill Agreement Policy</strong></p>
    <p>
      <span style="font-weight: 400;"
        >Upskill reserves the right to discontinue this agreement, and/or alter
        the terms and conditions at any time at its discretion .</span
      >
    </p>
    <p>&nbsp;</p>
    <p>
      <span style="font-weight: 400;"
        >This agreement has been executed by the parties on the signing
        date .</span
      >
    </p>
  </div>
</template>
<script>
export default {
  name: "termsConditions",
};
</script>
<style scoped>
ol {
  padding: 1em;
}
</style>
